<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 11:13:26
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id='page_Container' class='choiceGood'>
        <div class="page">
            <div id='main-container' class="main-container">
                <div class='choiceGoods'>
                    <van-checkbox-group v-model="result" @change="changeItem">
                        <van-checkbox v-for="item in dataRefund.memberOrderItemList" :key="item.id" :name="item.id" :disabled='!item.retreatQuantity' style='padding:12px 0;'>
                            <van-card :num="item.quantity" :desc="item.specificationValue" :title="item.productName" :thumb="item.productImg" />
                        </van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <div class='submitBtn'>
                <van-button round type="danger" @click='submitBtn'>提交</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import {
    mapGetters
} from 'vuex';
export default {
    components: {
        Toast
    },
    data() {
        return {
            commodityUrl: require('../assets/img/myCenter/commodity.png'),
            result: [],
            dataRefund: {},
            orderItemJsonList: [],
            orderCode: ''
        };
    },
    esvReady() {
        const ths = this;
        document.title = '申请退款';
        this.ESVStorage.getSavedValue('dataRefund', (data) => {
            ths.dataRefund = data;
        });
        this.dataRefund.refundOrderItemList.forEach((item, index) => {
            this.result.push(item.id);
        });
    },
    methods: {
        submitBtn() {
            const ths = this;
            if (ths.result.length <= 0) {
                Toast('请选择');
                return false;
            }
            const params = {
                orderCode: ths.orderCode,
                orderItemJsonList: JSON.stringify(ths.orderItemJsonList),
                merchantInfo: JSON.stringify(this.merchantInfoSwitch)
            };
            ths.$doRequest(
                {
                    url: '/order/queryMemberOrderItemForRefund',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.ESVStorage.putSavedValue(
                        'dataRefund',
                        data.result
                    );
                    ths.esvOpenPage({ name: 'OPRefund', query: ths.$route.query });
                }
            );
            this.ESVStorage.removeSavedValue('completedData');
        },
        changeItem(data) {
            const list = [];
            const ths = this;

            data.forEach((itemNew, index) => {
                ths.dataRefund.memberOrderItemList.forEach((item, index) => {
                    ths.orderCode = item.orderCode;
                    if (itemNew === item.id) {
                        list.push({
                            productId: item.productId,
                            skuCode: item.skuCode,
                            quantity: item.retreatQuantity
                        });
                    }
                });
            });
            this.orderItemJsonList = list;
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ])
    }
};
</script>
<style lang="scss" scoped>
.submitBtn {
    width: 100%;
    height: 60px;
    background: #fff;
    text-align: center;
    line-height: 60px;
    position: fixed;
    bottom: 0;
    left: 0;
    .van-button {
        width: 80%;
    }
}
.choiceGoods {
    background: #fff;
    padding: 0 12px;
    margin-bottom: 60px;
    .van-checkbox__label {
        width: 90%;
        background: #fff;
    }
}
</style>
